function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const e = "https://api.thumbmarkjs.com",
      n = {
  exclude: [],
  include: [],
  stabilize: ["private", "iframe"],
  logging: !0,
  timeout: 5e3,
  cache_api_call: !0,
  performance: !1
};

let t = _objectSpread({}, n);

function r(e, n) {
  t[e] = n;
}

const o = {
  private: [{
    exclude: ["canvas"],
    browsers: ["firefox", "safari>=17", "brave"]
  }, {
    exclude: ["audio"],
    browsers: ["samsungbrowser", "safari"]
  }, {
    exclude: ["fonts"],
    browsers: ["firefox"]
  }, {
    exclude: ["audio.sampleHash", "hardware.deviceMemory", "header.acceptLanguage.q", "system.hardwareConcurrency", "plugins"],
    browsers: ["brave"]
  }, {
    exclude: ["tls.extensions"],
    browsers: ["firefox", "chrome", "safari"]
  }, {
    exclude: ["header.acceptLanguage"],
    browsers: ["edge", "chrome"]
  }],
  iframe: [{
    exclude: ["permissions.camera", "permission.geolocation", "permissions.microphone", "system.applePayVersion", "system.cookieEnabled"],
    browsers: ["safari"]
  }],
  vpn: [{
    exclude: ["ip"]
  }]
};

function i(e) {
  let n = 0;

  for (let t = 0; t < e.length; ++t) n += Math.abs(e[t]);

  return n;
}

function a(e, n, t) {
  let r = [];

  for (let n = 0; n < e[0].data.length; n++) {
    let t = [];

    for (let r = 0; r < e.length; r++) t.push(e[r].data[n]);

    r.push(s(t));
  }

  const o = new Uint8ClampedArray(r);
  return new ImageData(o, n, t);
}

function s(e) {
  if (0 === e.length) return 0;
  const n = {};

  for (const t of e) n[t] = (n[t] || 0) + 1;

  let t = e[0];

  for (const e in n) n[e] > n[t] && (t = parseInt(e, 10));

  return t;
}

function c(e) {
  return e ^= e >>> 16, e = Math.imul(e, 2246822507), e ^= e >>> 13, e = Math.imul(e, 3266489909), (e ^= e >>> 16) >>> 0;
}

const l = new Uint32Array([597399067, 2869860233, 951274213, 2716044179]);

function u(e, n) {
  return e << n | e >>> 32 - n;
}

function d(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t;
  if (n = n ? 0 | n : 0, "string" == typeof e && (t = e, e = new TextEncoder().encode(t).buffer), !(e instanceof ArrayBuffer)) throw new TypeError("Expected key to be ArrayBuffer or string");
  const r = new Uint32Array([n, n, n, n]);
  !function (e, n) {
    const t = e.byteLength / 16 | 0,
          r = new Uint32Array(e, 0, 4 * t);

    for (let e = 0; e < t; e++) {
      const t = r.subarray(4 * e, 4 * (e + 1));
      t[0] = Math.imul(t[0], l[0]), t[0] = u(t[0], 15), t[0] = Math.imul(t[0], l[1]), n[0] = n[0] ^ t[0], n[0] = u(n[0], 19), n[0] = n[0] + n[1], n[0] = Math.imul(n[0], 5) + 1444728091, t[1] = Math.imul(t[1], l[1]), t[1] = u(t[1], 16), t[1] = Math.imul(t[1], l[2]), n[1] = n[1] ^ t[1], n[1] = u(n[1], 17), n[1] = n[1] + n[2], n[1] = Math.imul(n[1], 5) + 197830471, t[2] = Math.imul(t[2], l[2]), t[2] = u(t[2], 17), t[2] = Math.imul(t[2], l[3]), n[2] = n[2] ^ t[2], n[2] = u(n[2], 15), n[2] = n[2] + n[3], n[2] = Math.imul(n[2], 5) + 2530024501, t[3] = Math.imul(t[3], l[3]), t[3] = u(t[3], 18), t[3] = Math.imul(t[3], l[0]), n[3] = n[3] ^ t[3], n[3] = u(n[3], 13), n[3] = n[3] + n[0], n[3] = Math.imul(n[3], 5) + 850148119;
    }
  }(e, r), function (e, n) {
    const t = e.byteLength / 16 | 0,
          r = e.byteLength % 16,
          o = new Uint32Array(4),
          i = new Uint8Array(e, 16 * t, r);

    switch (r) {
      case 15:
        o[3] = o[3] ^ i[14] << 16;

      case 14:
        o[3] = o[3] ^ i[13] << 8;

      case 13:
        o[3] = o[3] ^ i[12], o[3] = Math.imul(o[3], l[3]), o[3] = u(o[3], 18), o[3] = Math.imul(o[3], l[0]), n[3] = n[3] ^ o[3];

      case 12:
        o[2] = o[2] ^ i[11] << 24;

      case 11:
        o[2] = o[2] ^ i[10] << 16;

      case 10:
        o[2] = o[2] ^ i[9] << 8;

      case 9:
        o[2] = o[2] ^ i[8], o[2] = Math.imul(o[2], l[2]), o[2] = u(o[2], 17), o[2] = Math.imul(o[2], l[3]), n[2] = n[2] ^ o[2];

      case 8:
        o[1] = o[1] ^ i[7] << 24;

      case 7:
        o[1] = o[1] ^ i[6] << 16;

      case 6:
        o[1] = o[1] ^ i[5] << 8;

      case 5:
        o[1] = o[1] ^ i[4], o[1] = Math.imul(o[1], l[1]), o[1] = u(o[1], 16), o[1] = Math.imul(o[1], l[2]), n[1] = n[1] ^ o[1];

      case 4:
        o[0] = o[0] ^ i[3] << 24;

      case 3:
        o[0] = o[0] ^ i[2] << 16;

      case 2:
        o[0] = o[0] ^ i[1] << 8;

      case 1:
        o[0] = o[0] ^ i[0], o[0] = Math.imul(o[0], l[0]), o[0] = u(o[0], 15), o[0] = Math.imul(o[0], l[1]), n[0] = n[0] ^ o[0];
    }
  }(e, r), function (e, n) {
    n[0] = n[0] ^ e.byteLength, n[1] = n[1] ^ e.byteLength, n[2] = n[2] ^ e.byteLength, n[3] = n[3] ^ e.byteLength, n[0] = n[0] + n[1] | 0, n[0] = n[0] + n[2] | 0, n[0] = n[0] + n[3] | 0, n[1] = n[1] + n[0] | 0, n[2] = n[2] + n[0] | 0, n[3] = n[3] + n[0] | 0, n[0] = c(n[0]), n[1] = c(n[1]), n[2] = c(n[2]), n[3] = c(n[3]), n[0] = n[0] + n[1] | 0, n[0] = n[0] + n[2] | 0, n[0] = n[0] + n[3] | 0, n[1] = n[1] + n[0] | 0, n[2] = n[2] + n[0] | 0, n[3] = n[3] + n[0] | 0;
  }(e, r);
  const o = new Uint8Array(r.buffer);
  return Array.from(o).map(e => e.toString(16).padStart(2, "0")).join("");
}

const m = 280;

function h(e, n) {
  return new Promise(t => setTimeout(t, e, n));
}

const f = ["Arial", "Arial Black", "Arial Narrow", "Arial Rounded MT", "Arimo", "Archivo", "Barlow", "Bebas Neue", "Bitter", "Bookman", "Calibri", "Cabin", "Candara", "Century", "Century Gothic", "Comic Sans MS", "Constantia", "Courier", "Courier New", "Crimson Text", "DM Mono", "DM Sans", "DM Serif Display", "DM Serif Text", "Dosis", "Droid Sans", "Exo", "Fira Code", "Fira Sans", "Franklin Gothic Medium", "Garamond", "Geneva", "Georgia", "Gill Sans", "Helvetica", "Impact", "Inconsolata", "Indie Flower", "Inter", "Josefin Sans", "Karla", "Lato", "Lexend", "Lucida Bright", "Lucida Console", "Lucida Sans Unicode", "Manrope", "Merriweather", "Merriweather Sans", "Montserrat", "Myriad", "Noto Sans", "Nunito", "Nunito Sans", "Open Sans", "Optima", "Orbitron", "Oswald", "Pacifico", "Palatino", "Perpetua", "PT Sans", "PT Serif", "Poppins", "Prompt", "Public Sans", "Quicksand", "Rajdhani", "Recursive", "Roboto", "Roboto Condensed", "Rockwell", "Rubik", "Segoe Print", "Segoe Script", "Segoe UI", "Sora", "Source Sans Pro", "Space Mono", "Tahoma", "Taviraj", "Times", "Times New Roman", "Titillium Web", "Trebuchet MS", "Ubuntu", "Varela Round", "Verdana", "Work Sans"],
      p = ["monospace", "sans-serif", "serif"];

function g(e, n) {
  if (!e) throw new Error("Canvas context not supported");
  return e.font = `72px ${n}`, e.measureText("WwMmLli0Oo").width;
}

function v() {
  var e;
  const n = document.createElement("canvas"),
        t = null !== (e = n.getContext("webgl")) && void 0 !== e ? e : n.getContext("experimental-webgl");
  if (t && "getParameter" in t) try {
    const e = (t.getParameter(t.VENDOR) || "").toString(),
          n = (t.getParameter(t.RENDERER) || "").toString();
    let r = {
      vendor: e,
      renderer: n,
      version: (t.getParameter(t.VERSION) || "").toString(),
      shadingLanguageVersion: (t.getParameter(t.SHADING_LANGUAGE_VERSION) || "").toString()
    };

    if (!n.length || !e.length) {
      const e = t.getExtension("WEBGL_debug_renderer_info");

      if (e) {
        const n = (t.getParameter(e.UNMASKED_VENDOR_WEBGL) || "").toString(),
              o = (t.getParameter(e.UNMASKED_RENDERER_WEBGL) || "").toString();
        n && (r.vendorUnmasked = n), o && (r.rendererUnmasked = o);
      }
    }

    return r;
  } catch (e) {}
  return "undefined";
}

function w() {
  const e = new Float32Array(1),
        n = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], n[3];
}

const y = (e, n, t, r) => {
  const o = (t - n) / r;
  let i = 0;

  for (let t = 0; t < r; t++) {
    i += e(n + (t + .5) * o);
  }

  return i * o;
};

function S(e, n) {
  const t = {};
  return n.forEach(n => {
    const r = function (e) {
      if (0 === e.length) return null;
      const n = {};
      e.forEach(e => {
        const t = String(e);
        n[t] = (n[t] || 0) + 1;
      });
      let t = e[0],
          r = 1;
      return Object.keys(n).forEach(e => {
        n[e] > r && (t = e, r = n[e]);
      }), t;
    }(e.map(e => n in e ? e[n] : void 0).filter(e => void 0 !== e));

    r && (t[n] = r);
  }), t;
}

const b = ["accelerometer", "accessibility", "accessibility-events", "ambient-light-sensor", "background-fetch", "background-sync", "bluetooth", "camera", "clipboard-read", "clipboard-write", "device-info", "display-capture", "gyroscope", "geolocation", "local-fonts", "magnetometer", "microphone", "midi", "nfc", "notifications", "payment-handler", "persistent-storage", "push", "speaker", "storage-access", "top-level-storage-access", "window-management", "query"];

function M() {
  var e, n, t, r, o, i;
  if ("undefined" == typeof navigator) return {
    name: "unknown",
    version: "unknown"
  };
  const a = navigator.userAgent,
        s = [/(?<name>SamsungBrowser)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>EdgA|EdgiOS|Edg)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>OPR|OPX)\/(?<version>\d+(?:\.\d+)+)/, /Opera[\s\/](?<version>\d+(?:\.\d+)+)/, /Opera Mini\/(?<version>\d+(?:\.\d+)+)/, /Opera Mobi\/(?<version>\d+(?:\.\d+)+)/, /(?<name>Vivaldi)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>Brave)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>CriOS)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>FxiOS)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>Chrome|Chromium)\/(?<version>\d+(?:\.\d+)+)/, /(?<name>Firefox|Waterfox|Iceweasel|IceCat)\/(?<version>\d+(?:\.\d+)+)/, /Version\/(?<version1>[\d.]+).*Safari\/[\d.]+|(?<name>Safari)\/(?<version2>[\d.]+)/, /(?<name>MSIE|Trident|IEMobile).+?(?<version>\d+(?:\.\d+)+)/, /(?<name>[A-Za-z]+)\/(?<version>\d+(?:\.\d+)+)/],
        c = {
    edg: "Edge",
    edga: "Edge",
    edgios: "Edge",
    opr: "Opera",
    opx: "Opera",
    crios: "Chrome",
    fxios: "Firefox",
    samsung: "SamsungBrowser",
    vivaldi: "Vivaldi",
    brave: "Brave"
  };

  for (const l of s) {
    const s = a.match(l);

    if (s) {
      let a = null === (e = s.groups) || void 0 === e ? void 0 : e.name,
          u = (null === (n = s.groups) || void 0 === n ? void 0 : n.version) || (null === (t = s.groups) || void 0 === t ? void 0 : t.version1) || (null === (r = s.groups) || void 0 === r ? void 0 : r.version2);

      if (a || !(null === (o = s.groups) || void 0 === o ? void 0 : o.version1) && !(null === (i = s.groups) || void 0 === i ? void 0 : i.version2) || (a = "Safari"), !a && l.source.includes("Opera Mini") && (a = "Opera Mini"), !a && l.source.includes("Opera Mobi") && (a = "Opera Mobi"), !a && l.source.includes("Opera") && (a = "Opera"), !a && s[1] && (a = s[1]), !u && s[2] && (u = s[2]), a) {
        return {
          name: c[a.toLowerCase()] || a,
          version: u || "unknown"
        };
      }
    }
  }

  return {
    name: "unknown",
    version: "unknown"
  };
}

function P() {
  if ("undefined" == typeof navigator || !navigator.userAgent) return !1;
  const e = navigator.userAgent;
  return /Mobi|Android|iPhone|iPod|IEMobile|Opera Mini|Opera Mobi|webOS|BlackBerry|Windows Phone/i.test(e) && !/iPad/i.test(e);
}

function E() {
  let e = [];
  const n = {
    "prefers-contrast": ["high", "more", "low", "less", "forced", "no-preference"],
    "any-hover": ["hover", "none"],
    "any-pointer": ["none", "coarse", "fine"],
    pointer: ["none", "coarse", "fine"],
    hover: ["hover", "none"],
    update: ["fast", "slow"],
    "inverted-colors": ["inverted", "none"],
    "prefers-reduced-motion": ["reduce", "no-preference"],
    "prefers-reduced-transparency": ["reduce", "no-preference"],
    scripting: ["none", "initial-only", "enabled"],
    "forced-colors": ["active", "none"]
  };
  return Object.keys(n).forEach(t => {
    n[t].forEach(n => {
      matchMedia(`(${t}: ${n})`).matches && e.push(`${t}: ${n}`);
    });
  }), e;
}

function A() {
  if ("https:" === window.location.protocol && "function" == typeof window.ApplePaySession) try {
    const e = window.ApplePaySession.supportsVersion;

    for (let n = 15; n > 0; n--) if (e(n)) return n;
  } catch (e) {
    return 0;
  }
  return 0;
}

const C = "SamsungBrowser" !== M().name ? 1 : 3;
let x,
    k = null;

const I = {
  audio: async function () {
    return async function () {
      return new Promise((e, n) => {
        try {
          const n = 44100,
                t = 5e3,
                r = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, t, n),
                o = r.createBufferSource(),
                a = r.createOscillator();
          a.frequency.value = 1e3;
          const s = r.createDynamicsCompressor();
          let c;
          s.threshold.value = -50, s.knee.value = 40, s.ratio.value = 12, s.attack.value = 0, s.release.value = .2, a.connect(s), s.connect(r.destination), a.start(), r.oncomplete = n => {
            c = n.renderedBuffer.getChannelData(0), e({
              sampleHash: i(c),
              maxChannels: r.destination.maxChannelCount,
              channelCountMode: o.channelCountMode
            });
          }, r.startRendering();
        } catch (e) {
          console.error("Error creating audio fingerprint:", e), n(e);
        }
      });
    }();
  },
  canvas: async function () {
    return new Promise(e => {
      const n = Array.from({
        length: 3
      }, () => function () {
        const e = document.createElement("canvas"),
              n = e.getContext("2d");
        if (!n) return new ImageData(1, 1);
        e.width = m, e.height = 20;
        const t = n.createLinearGradient(0, 0, e.width, e.height);
        t.addColorStop(0, "red"), t.addColorStop(1 / 6, "orange"), t.addColorStop(2 / 6, "yellow"), t.addColorStop(.5, "green"), t.addColorStop(4 / 6, "blue"), t.addColorStop(5 / 6, "indigo"), t.addColorStop(1, "violet"), n.fillStyle = t, n.fillRect(0, 0, e.width, e.height);
        const r = "Random Text WMwmil10Oo";
        n.font = "23.123px Arial", n.fillStyle = "black", n.fillText(r, -5, 15), n.fillStyle = "rgba(0, 0, 255, 0.5)", n.fillText(r, -3.3, 17.7), n.beginPath(), n.moveTo(0, 0), n.lineTo(2 * e.width / 7, e.height), n.strokeStyle = "white", n.lineWidth = 2, n.stroke();
        const o = n.getImageData(0, 0, e.width, e.height);
        return o;
      }());
      e({
        commonPixelsHash: d(a(n, m, 20).data.toString()).toString()
      });
    });
  },
  fonts: async function (e) {
    return new Promise((e, n) => {
      try {
        !async function (e) {
          for (var n; !document.body;) await h(50);

          const t = document.createElement("iframe");
          t.setAttribute("frameBorder", "0");
          const r = t.style;
          r.setProperty("position", "fixed"), r.setProperty("display", "block", "important"), r.setProperty("visibility", "visible"), r.setProperty("border", "0"), r.setProperty("opacity", "0"), t.src = "about:blank", document.body.appendChild(t);
          const o = t.contentDocument || (null === (n = t.contentWindow) || void 0 === n ? void 0 : n.document);
          if (!o) throw new Error("Iframe document is not accessible");
          e({
            iframe: o
          }), setTimeout(() => {
            document.body.removeChild(t);
          }, 0);
        }(async _ref => {
          let n = _ref.iframe;
          const t = n.createElement("canvas").getContext("2d"),
                r = p.map(e => g(t, e));
          let o = {};
          f.forEach(e => {
            const n = g(t, e);
            r.includes(n) || (o[e] = n);
          }), e(o);
        });
      } catch (e) {
        n({
          error: "unsupported"
        });
      }
    });
  },
  hardware: function () {
    return new Promise((e, n) => {
      const t = void 0 !== navigator.deviceMemory ? navigator.deviceMemory : 0,
            r = window.performance && window.performance.memory ? window.performance.memory : 0;
      e({
        videocard: v(),
        architecture: w(),
        deviceMemory: t.toString() || "undefined",
        jsHeapSizeLimit: r.jsHeapSizeLimit || 0
      });
    });
  },
  locales: function () {
    return new Promise(e => {
      e({
        languages: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });
    });
  },
  math: function () {
    return new Promise(e => {
      e({
        acos: Math.acos(.5),
        asin: y(Math.asin, -1, 1, 97),
        cos: y(Math.cos, 0, Math.PI, 97),
        largeCos: Math.cos(1e20),
        largeSin: Math.sin(1e20),
        largeTan: Math.tan(1e20),
        sin: y(Math.sin, -Math.PI, Math.PI, 97),
        tan: y(Math.tan, 0, 2 * Math.PI, 97)
      });
    });
  },
  permissions: async function (e) {
    let n = (null == e ? void 0 : e.permissions_to_check) || b;
    const t = Array.from({
      length: 3
    }, () => async function (e) {
      const n = {};

      for (const t of e) try {
        const e = await navigator.permissions.query({
          name: t
        });
        n[t] = e.state.toString();
      } catch (e) {}

      return n;
    }(n));
    return Promise.all(t).then(e => S(e, n));
  },
  plugins: async function () {
    const e = [];
    if (navigator.plugins) for (let n = 0; n < navigator.plugins.length; n++) {
      const t = navigator.plugins[n];
      e.push([t.name, t.filename, t.description].join("|"));
    }
    return new Promise(n => {
      n({
        plugins: e
      });
    });
  },
  screen: function () {
    return new Promise(e => {
      const n = {
        is_touchscreen: navigator.maxTouchPoints > 0,
        maxTouchPoints: navigator.maxTouchPoints,
        colorDepth: screen.colorDepth,
        mediaMatches: E()
      };
      P() && navigator.maxTouchPoints > 0 && (n.resolution = function () {
        const e = window.screen.width,
              n = window.screen.height,
              t = Math.max(e, n).toString(),
              r = Math.min(e, n).toString();
        return `${t}x${r}`;
      }()), e(n);
    });
  },
  system: function () {
    return new Promise(e => {
      const n = M();
      e({
        platform: window.navigator.platform,
        productSub: navigator.productSub,
        product: navigator.product,
        useragent: navigator.userAgent,
        hardwareConcurrency: navigator.hardwareConcurrency,
        browser: {
          name: n.name,
          version: n.version
        },
        mobile: P(),
        applePayVersion: A(),
        cookieEnabled: window.navigator.cookieEnabled
      });
    });
  },
  webgl: async function () {
    "undefined" != typeof document && (x = document.createElement("canvas"), x.width = 200, x.height = 100, k = x.getContext("webgl"));

    try {
      if (!k) throw new Error("WebGL not supported");
      const e = Array.from({
        length: C
      }, () => function () {
        try {
          if (!k) throw new Error("WebGL not supported");
          const e = "\n          attribute vec2 position;\n          void main() {\n              gl_Position = vec4(position, 0.0, 1.0);\n          }\n      ",
                n = "\n          precision mediump float;\n          void main() {\n              gl_FragColor = vec4(0.812, 0.195, 0.553, 0.921); // Set line color\n          }\n      ",
                t = k.createShader(k.VERTEX_SHADER),
                r = k.createShader(k.FRAGMENT_SHADER);
          if (!t || !r) throw new Error("Failed to create shaders");
          if (k.shaderSource(t, e), k.shaderSource(r, n), k.compileShader(t), !k.getShaderParameter(t, k.COMPILE_STATUS)) throw new Error("Vertex shader compilation failed: " + k.getShaderInfoLog(t));
          if (k.compileShader(r), !k.getShaderParameter(r, k.COMPILE_STATUS)) throw new Error("Fragment shader compilation failed: " + k.getShaderInfoLog(r));
          const o = k.createProgram();
          if (!o) throw new Error("Failed to create shader program");
          if (k.attachShader(o, t), k.attachShader(o, r), k.linkProgram(o), !k.getProgramParameter(o, k.LINK_STATUS)) throw new Error("Shader program linking failed: " + k.getProgramInfoLog(o));
          k.useProgram(o);
          const i = 137,
                a = new Float32Array(4 * i),
                s = 2 * Math.PI / i;

          for (let e = 0; e < i; e++) {
            const n = e * s;
            a[4 * e] = 0, a[4 * e + 1] = 0, a[4 * e + 2] = Math.cos(n) * (x.width / 2), a[4 * e + 3] = Math.sin(n) * (x.height / 2);
          }

          const c = k.createBuffer();
          k.bindBuffer(k.ARRAY_BUFFER, c), k.bufferData(k.ARRAY_BUFFER, a, k.STATIC_DRAW);
          const l = k.getAttribLocation(o, "position");
          k.enableVertexAttribArray(l), k.vertexAttribPointer(l, 2, k.FLOAT, !1, 0, 0), k.viewport(0, 0, x.width, x.height), k.clearColor(0, 0, 0, 1), k.clear(k.COLOR_BUFFER_BIT), k.drawArrays(k.LINES, 0, 2 * i);
          const u = new Uint8ClampedArray(x.width * x.height * 4);
          k.readPixels(0, 0, x.width, x.height, k.RGBA, k.UNSIGNED_BYTE, u);
          return new ImageData(u, x.width, x.height);
        } catch (e) {
          return new ImageData(1, 1);
        } finally {
          k && (k.bindBuffer(k.ARRAY_BUFFER, null), k.useProgram(null), k.viewport(0, 0, k.drawingBufferWidth, k.drawingBufferHeight), k.clearColor(0, 0, 0, 0));
        }
      }());
      return {
        commonPixelsHash: d(a(e, x.width, x.height).data.toString()).toString()
      };
    } catch (e) {
      return {
        webgl: "unsupported"
      };
    }
  }
},
      O = {},
      T = {
  timeout: "true"
},
      R = (e, n, t) => {
  O[e] = n;
};

function _() {
  return "1.2.0";
}

function L(e, n) {
  var t;
  let r = M();

  if ("unknown" === r.name && e.system && "object" == typeof e.system && !Array.isArray(e.system)) {
    const n = e.system.browser;

    if (n && "object" == typeof n && !Array.isArray(n)) {
      const e = n;
      r = {
        name: e.name || "unknown",
        version: e.version || "unknown"
      };
    }
  }

  const i = r.name.toLowerCase(),
        a = r.version.split(".")[0] || "0",
        s = parseInt(a, 10),
        c = [...((null == n ? void 0 : n.exclude) || [])],
        l = (null == n ? void 0 : n.stabilize) || [],
        u = (null == n ? void 0 : n.include) || [];

  for (const e of l) {
    const n = o[e];
    if (n) for (const e of n) {
      const n = !("browsers" in e),
            r = !n && (null === (t = e.browsers) || void 0 === t ? void 0 : t.some(e => {
        const n = e.match(/(.+?)(>=)(\d+)/);

        if (n) {
          const _n2 = _slicedToArray(n, 4),
                e = _n2[1],
                t = _n2[3],
                r = parseInt(t, 10);

          return i === e && s >= r;
        }

        return i === e;
      }));
      (n || r) && c.push(...e.exclude);
    }
  }

  return function e(n) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const r = {};

    for (const _ref2 of Object.entries(n)) {
      var _ref3 = _slicedToArray(_ref2, 2);

      const o = _ref3[0];
      const i = _ref3[1];
      {
        const n = t ? `${t}.${o}` : o;

        if ("object" != typeof i || Array.isArray(i) || null === i) {
          const e = c.some(e => n.startsWith(e)),
                t = u.some(e => n.startsWith(e));
          e && !t || (r[o] = i);
        } else {
          const t = e(i, n);
          Object.keys(t).length > 0 && (r[o] = t);
        }
      }
    }

    return r;
  }(e);
}

const B = "thumbmark_visitor_id";
let D = null,
    N = null;

const U = (n, t) => {
  if (n.cache_api_call && N) return Promise.resolve(N);
  if (D) return D;

  const r = `${e}/thumbmark`,
        o = function () {
    try {
      return localStorage.getItem(B);
    } catch (e) {
      return null;
    }
  }(),
        i = {
    components: t,
    options: n,
    clientHash: d(JSON.stringify(t)),
    version: "1.2.0"
  };

  o && (i.visitorId = o);
  const a = fetch(r, {
    method: "POST",
    headers: {
      "x-api-key": n.api_key,
      Authorization: "custom-authorized",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(i)
  }).then(e => {
    if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`);
    return e.json();
  }).then(e => (e.visitorId && e.visitorId !== o && function (e) {
    try {
      localStorage.setItem(B, e);
    } catch (e) {}
  }(e.visitorId), N = e, D = null, e)).catch(e => (console.error("Error fetching pro data", e), D = null, null)),
        s = n.timeout || 5e3,
        c = new Promise(e => {
    setTimeout(() => {
      e({
        info: {
          timed_out: !0
        },
        version: "1.2.0"
      });
    }, s);
  });
  return D = Promise.race([a, c]), D;
};

async function F(t) {
  const r = _objectSpread(_objectSpread({}, n), t),
        o = _objectSpread(_objectSpread({}, I), O),
        _await$j = await j(o, r),
        i = _await$j.elapsed,
        a = _await$j.resolvedComponents,
        s = r.api_key ? U(r, a) : null,
        c = s ? await s : null,
        l = r.performance ? {
    elapsed: i
  } : {},
        u = L((null == c ? void 0 : c.components) || {}, r),
        m = _objectSpread(_objectSpread({}, a), u),
        h = (null == c ? void 0 : c.info) || {
    uniqueness: {
      score: "api only"
    }
  },
        f = d(JSON.stringify(m));

  (async function (n, t, r) {
    var o;
    const i = `${e}/log`,
          a = {
      thumbmark: n,
      components: t,
      version: "1.2.0",
      options: r,
      path: null === (o = null === window || void 0 === window ? void 0 : window.location) || void 0 === o ? void 0 : o.pathname
    };

    if (!sessionStorage.getItem("_tmjs_l") && Math.random() < 1e-4) {
      sessionStorage.setItem("_tmjs_l", "1");

      try {
        await fetch(i, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(a)
        });
      } catch (e) {}
    }
  })(f, m, r).catch(() => {});
  return _objectSpread(_objectSpread({}, (null == c ? void 0 : c.visitorId) && {
    visitorId: c.visitorId
  }), {}, {
    thumbmark: f,
    components: m,
    info: h,
    version: "1.2.0"
  }, l);
}

async function j(e, t) {
  const r = _objectSpread(_objectSpread({}, n), t),
        o = Object.entries(e).filter(_ref4 => {
    let _ref5 = _slicedToArray(_ref4, 1),
        e = _ref5[0];

    var n;
    return !(null === (n = null == r ? void 0 : r.exclude) || void 0 === n ? void 0 : n.includes(e));
  }).filter(_ref6 => {
    let _ref7 = _slicedToArray(_ref6, 1),
        e = _ref7[0];

    var n, t, o, i;
    return (null === (n = null == r ? void 0 : r.include) || void 0 === n ? void 0 : n.some(e => e.includes("."))) ? null === (t = null == r ? void 0 : r.include) || void 0 === t ? void 0 : t.some(n => n.startsWith(e)) : 0 === (null === (o = null == r ? void 0 : r.include) || void 0 === o ? void 0 : o.length) || (null === (i = null == r ? void 0 : r.include) || void 0 === i ? void 0 : i.includes(e));
  }),
        i = o.map(_ref8 => {
    let _ref9 = _slicedToArray(_ref8, 1),
        e = _ref9[0];

    return e;
  }),
        a = o.map(_ref10 => {
    let _ref11 = _slicedToArray(_ref10, 2),
        e = _ref11[0],
        n = _ref11[1];

    return n(t);
  }),
        s = await function (e, n, t) {
    return Promise.all(e.map(e => {
      const r = performance.now();
      return Promise.race([e.then(e => ({
        value: e,
        elapsed: performance.now() - r
      })), (o = n, i = t, new Promise(e => {
        setTimeout(() => e(i), o);
      })).then(e => ({
        value: e,
        elapsed: performance.now() - r
      }))]);
      var o, i;
    }));
  }(a, (null == r ? void 0 : r.timeout) || 5e3, T),
        c = {},
        l = {};

  s.forEach((e, n) => {
    var t;
    null != e.value && (l[i[n]] = e.value, c[i[n]] = null !== (t = e.elapsed) && void 0 !== t ? t : 0);
  });
  const u = L(l, r);
  return {
    elapsed: c,
    resolvedComponents: u
  };
}

async function G() {
  return (await F(t)).components;
}

async function W(e) {
  try {
    const n = await F(t);
    return e ? {
      hash: n.thumbmark.toString(),
      data: n.components
    } : n.thumbmark.toString();
  } catch (e) {
    throw e;
  }
}

async function V() {
  try {
    const _await$j2 = await j(I, t),
          e = _await$j2.elapsed,
          n = _await$j2.resolvedComponents;

    return _objectSpread(_objectSpread({}, n), {}, {
      elapsed: e
    });
  } catch (e) {
    throw e;
  }
}

class H {
  constructor(e) {
    this.options = _objectSpread(_objectSpread({}, n), e);
  }

  async get(e) {
    return F(_objectSpread(_objectSpread({}, this.options), e));
  }

  getVersion() {
    return "1.2.0";
  }

  includeComponent(e, n) {
    R(e, n);
  }

}

export { H as Thumbmark, L as filterThumbmarkData, W as getFingerprint, G as getFingerprintData, V as getFingerprintPerformance, F as getThumbmark, _ as getVersion, R as includeComponent, r as setOption, o as stabilizationExclusionRules };